import React from 'react'

export const DiagonalConnectionOne = ({idCenario = 0, isTransparente = false, distance}) => {
    return (
        <>
            {idCenario===0 && 
                <div id={333} className={isTransparente ? 'diagonal-connection-one-transparente' :'diagonal-connection-one'} align="center" >
                {distance}
                </div>
            }
            {idCenario===1 && 
                <div id={333} className={isTransparente ? 'diagonal-connection-one-transparente' :'diagonal-connection-one-cenario1'} align="center" >
                {distance}
                </div>
            }
            {idCenario===2 && 
                <div id={333} className={isTransparente ? 'diagonal-connection-one-transparente' :'diagonal-connection-one-cenario2'} align="center" >
                {distance}
                </div>
            }
        </>
    )
}

export default DiagonalConnectionOne
